var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50679 4.3609C5.53901 4.1466 5.67186 3.97156 5.85083 3.88327C5.93255 3.84279 6.0227 3.82049 6.11831 3.82049H9.9971C10.4566 3.82049 10.8856 3.85165 11.277 3.91703C11.3889 3.93551 11.4975 3.95689 11.6036 3.98087C11.7091 4.00531 11.812 4.03265 11.9117 4.06259C11.9613 4.07787 12.0103 4.09375 12.0583 4.10948C12.2509 4.17547 12.4299 4.25352 12.5949 4.34349C12.7891 3.06365 12.5933 2.19225 11.9239 1.40318C11.1857 0.534375 9.85361 0.162598 8.14896 0.162598H3.20009C2.85192 0.162598 2.55488 0.424247 2.50109 0.780444L0.439846 14.2849C0.399206 14.5521 0.598562 14.7931 0.859246 14.7931H3.91446L5.50679 4.3609Z",
    fill: "#28356A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.077a9f39e0c2fa98cd567456266a7ae9.svg";
export { ForwardRef as ReactComponent };